// extracted by mini-css-extract-plugin
export default {"icon":"IconLinked_icon__xDCQp"};